export default {
    IS_NOT_EMPTY: 'Podaci su nepotpuni',
    IS_EMAIL: 'Email nije validan',
    MIN_LENGTH_6: 'Minimum 6 karaktera',
    MIN_LENGTH_3: 'Unesite minimum 3 karaktera',
    IS_MOBILE_PHONE: 'Broj telefona nije validan',
    CONTAINS_facebook: 'Facebook link nije validan',
    CONTAINS_instagram: 'Instagram link nije validan',
    CONTAINS_linkedin: 'LinkedIn link nije validan',
    CONTAINS_twitter: 'X-Twitter link nije validan',
    CONTAINS_tiktok: 'Tik Tok link nije validan',
    CONTAINS_review: 'Google link nije validan',
    IS_NUMBER_STRING: 'Nevalidna vrednost',
    INVALID_PIB: 'PIB nije validan',
    IS_POSITIVE: 'Broj mora biti pozitivan',
    IS_DATE_STRING: 'Nevalidan format',
    IS_PHONE_NUMBER: 'Broj telefona mora biti sa pozivnim brojem (+38164123123)',
    MAXIMUM_100: 'Prekoračili ste dozvoljeni broj karaktera od 100',
    MAXIMUM_255: 'Prekoračili ste dozvoljeni broj karaktera od 255',
    MAXIMUM_600: 'Prekoračili ste dozvoljeni broj karaktera od 600',
    MAXIMUM_1: 'Broj mora biti izmedju 1-100',
    MINIMUM_0: 'Broj mora biti veći od 0',
    MINIMUM_15: 'Broj mora biti veći od 15',
    MAXIMUM_180: 'Broj mora biti manji od 180',

    IS_ARRAY: 'Morate odabrati bar jednu opciju',
    OFFER: {
        EXPIRED: 'Ovaj oglas je istekao.',
        NOT_FOUND: 'Ovaj oglas nije pronađen.',
    },
    DISCOUNT: {
        ALREADY_ACTIVE_DISCOUNT_FOR_OFFER_CATEGORY: 'Kategorija vec ima popust za odabrani vremenski okvir',
    },
    CATEGORY: {
        CATEGORY_NOT_FOUND: 'Kategorija je obrisana!',
    },
    AVAILABILITY: {
        TO_IS_SAME_OR_BEFORE_FROM: `Polje 'Do datuma' mora biti posle datuma 'Od datuma'.`,
        DIFFERENT_TIMEZONE: `Ovaj raspored je u drugoj vremenskoj zoni. Molimo kreirajte novi raspored.`,
    },
    LOCATION: {
        DIFFERENT_TIMEZONE: `Promena lokacije je moguca samo u istoj vremenskoj zoni.`,
    },
    USER: {
        TAKEN_EMAIL: 'Ova email adresa je već zauzeta',
        EMAIL_BAD_FORMAT: 'Email nije validan',
        EMAIL_NOT_VERIFIED: 'Molimo prvo protvrdite Vaš email',
        BAD_CREDENTIALS: 'Kredencijali nisu validni',
        INVALID_OLD_PASSWORD: 'Lozinka nije validna',
        RESEND_LIMIT_REACHED: 'Dosegnut je limit za ponovno slanje SMS-a',
        INVALID_CHANGE_MOBILE_TOKEN: 'Verifikacioni kod je nevažeći',
        ALREADY_PART_OF_THE_COMPANY: 'Klijent već postoji u kompaniji!',
        HAS_ACTIVE_COMPANY: 'Nije moguće izbrisati profil sa aktivnom kompanijom.',
    },
    COMPANY: {
        NAME_EXIST: 'Naziv kompanije već postoji',
        PIB_EXIST: 'PIB već postoji',
        SUBDOMAIN_NOT_ALLOWED: 'Subdomain ime nije validno!',
        SUBDOMAIN_EXISTS: 'Subdomain ime je već zauzeto',
    },
    RATING: {
        ALREADY_RATED: 'Usluga je vec ocenjena',
        TOKEN_EXPIRED: 'Vreme za ocenjivanje je isteklo!',
    },
    CUSTOM_REMINDER: {
        ILLEGAL_CUSTOM_REMINDER_TYPE: 'Molimo izaberite tip podestnika!',
    },
}
